import "../styles/PrivacyPolicy.css";


function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <div className="privacy-box">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-text">
          This Privacy Policy explains how Huge Notifier collects, uses, and protects user data.
        </p>

        <section className="privacy-section">
          <h2>1. Data We Collect</h2>
          <ul>
            <li>Discord user IDs, messages (if applicable), and interaction logs.</li>
            <li>Server information where the bot is used.</li>
            <li>No sensitive or personally identifiable information is collected.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>2. How We Use Data</h2>
          <ul>
            <li>To provide bot features and improve functionality.</li>
            <li>To track usage analytics and prevent abuse.</li>
            <li>To store necessary data for game-related tracking (if applicable).</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. Data Storage & Security</h2>
          <ul>
            <li>Data is stored securely and not shared with third parties.</li>
            <li>Data is retained as long as necessary for bot functionality.</li>
            <li>Users may request data deletion by contacting on discord: masterhaxixu.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. Changes to This Policy</h2>
          <ul>
            <li>Updates may be made to this policy. Users will be notified of major changes.</li>
          </ul>
        </section>

        <footer className="privacy-footer">Last Updated: 12/02/2025 15:39 GMT+1</footer>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
